import {
  TenantNotification,
  TenantNotificationCategory,
} from '../../../../../../backend-core-lib/app/common-shared/account/models';

import { ApiRequestBuilder, ApiService } from '../../../api';

import { from } from 'rxjs';
import {
  Component,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { getQueryParamsFromUrl } from '../../../utils/browser/get-query-params-from-url';
import { getUrlWithoutQueryParams } from '../../../utils/browser/get-url-without-query-params';
import { getNotificationIcon } from '../../../../app/shared/utils/notifications/get-notification-icon';
import { navigateToNotificationAction } from '../../../../app/shared/utils/notifications/navigate-to-notification-action';
import { orderBy } from 'lodash';

@Component({
  selector: 'tenant-notifications',
  templateUrl: './tenant-notifications.component.html',
  styleUrls: ['./tenant-notifications.component.scss'],
  standalone: false,
  encapsulation: ViewEncapsulation.None,
})
export class TenantNotificationsComponent implements OnChanges, OnDestroy {
  @HostBinding('class')
  readonly cssClass = 'tenant-notifications ml-1';

  @Input()
  category!: TenantNotificationCategory;

  tenantNotifications: TenantNotification[] = [];

  initialized = false;
  countNotSeen = 0;

  refreshEveryMilliSeconds = 15000;

  constructor(
    private apiService: ApiService,
    private router: Router,
  ) {}

  ngOnChanges() {
    this.refreshNotifications(true);
    this.setTimeoutAndRefresh();
  }

  async refreshNotifications(fetchAll = true): Promise<void> {
    let lastNotificationDate = 0;
    if (this.tenantNotifications?.length) {
      (this.tenantNotifications || []).forEach((notification) => {
        if (notification.createdAt > lastNotificationDate) {
          lastNotificationDate = notification.createdAt;
        }
      });
    }
    const sessionRequest = new ApiRequestBuilder('getTenantNotifications')
      .replaceUrl({
        category: this.category,
        date: fetchAll ? 0 : lastNotificationDate,
      })
      .build();
    const resultApi = await this.apiService.callApi(sessionRequest);
    if (!resultApi || resultApi.status === 'error') {
      this.initialized = true;
      return;
    }
    if (fetchAll) {
      this.tenantNotifications = resultApi.data;
    } else {
      (resultApi?.data || []).forEach((notification: TenantNotification) => {
        this.tenantNotifications.push(notification);
      });
    }

    this.countNotSeen = 0;
    if (this.tenantNotifications.length) {
      (this.tenantNotifications || []).forEach((notification) => {
        if (!notification.seenAt) {
          this.countNotSeen++;
        }
      });
    }

    console.log(this.tenantNotifications);
    this.tenantNotifications = orderBy(
      this.tenantNotifications,
      'createdAt',
      'desc',
    );
    this.initialized = true;
  }

  setTimeoutAndRefresh(): void {
    if (this.refreshEveryMilliSeconds) {
      setTimeout(() => {
        this.refreshNotifications(false);
        this.setTimeoutAndRefresh();
      }, this.refreshEveryMilliSeconds);
    }
  }
  getNotificationIcon(tenantNotification: TenantNotification): string {
    return getNotificationIcon(tenantNotification);
  }
  async notificationClicked(
    tenantNotification: TenantNotification,
  ): Promise<void> {
    await this.setNotificationAsSeen(tenantNotification);
    await navigateToNotificationAction(tenantNotification, this.router);
  }

  removeNotificationClicked(tenantNotification: TenantNotification): void {
    console.log('removeNotificationClicked');
    console.log(tenantNotification);
  }

  getUrlWithoutQueryParams(url: string): string {
    return getUrlWithoutQueryParams(url);
  }
  getQueryParamsFromUrl(url: string): Record<string, string> | undefined {
    return getQueryParamsFromUrl(url);
  }
  async setNotificationAsSeen(
    tenantNotification: TenantNotification,
  ): Promise<void> {
    const apiRequest = new ApiRequestBuilder('setTenantNotificationAsSeen')
      .replaceUrl({ notificationId: tenantNotification.uid })
      .build();
    await this.apiService.callApi(apiRequest);
  }

  ngOnDestroy(): void {
    this.refreshEveryMilliSeconds = 0;
  }
}
